/*
  CHEEKYGLO . QUICK VIEW ADD CONFIRMATION

  The theme opens the cart drawer on "variant:add" but never closes the quick
  view behind it, so two overlays stack up. This confirms the add on the
  button, then closes the quick view so the cart drawer is the only thing
  left on screen.

  Delete this file and its <script> in theme.liquid to revert.
*/
(function () {
  var CONFIRM_MS = 850;

  document.addEventListener('variant:add', function (event) {
    var form = event.target;
    if (!form || typeof form.closest !== 'function') return;

    var modal = form.closest('quick-buy-modal');
    if (!modal) return;

    var panel = modal.querySelector('.qv');
    var label = (panel && panel.getAttribute('data-added-label')) || 'Added';
    var button = form.querySelector('button[type="submit"]');
    var content = button && button.querySelector('button-content');

    if (button && content) {
      button.classList.add('qv-atc--added');
      content.textContent = '\u2713 ' + label;

      // Keep whichever hover animation the theme is configured for in sync
      if (content.hasAttribute('up-text')) content.setAttribute('up-text', '\u2713 ' + label);
      if (content.hasAttribute('rotated-text')) content.setAttribute('rotated-text', '\u2713 ' + label);
    }

    setTimeout(function () {
      if (typeof modal.hide === 'function') {
        modal.hide();
      } else {
        modal.removeAttribute('open');
      }
    }, CONFIRM_MS);
  });
})();
